import React, { createContext } from 'react';
import { User } from 'src/models/user';

export interface UserContextType {
  users: User[];
  setUsers: React.Dispatch<React.SetStateAction<User[]>>;
  addUser: (user: User) => Promise<null | string>;
  editUser: (user: Partial<User> & { _id: string }) => void;
  deleteUser: (userId: string) => Promise<string | null>;
}

export const UserContext = createContext<UserContextType>({} as UserContextType);
